@if (!media.isActive('lt-md')) {
  <app-chart-items chartName="Oricon" [infos]="infos" [dataCollections]="dataCollections$ | async">
  </app-chart-items>
}
@if (media.isActive('lt-md')) {
  <app-sp-chart-items
    chartName="Oricon"
    [infos]="infos"
    [dataCollections]="dataCollections$ | async"
    >
  </app-sp-chart-items>
}
